/**
 * Created by wangjianwen on 2017/10/16.
 */
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';
import Lockr from 'lockr'
import {WhiteList,SessionStorageWay} from '../config'

let state = {
    headerState:null,
    footerInfo:null,
    userType:null,
    token: null,
    currentUser: null,
    pageInfo:null,
    certType:null,
    projectToken:null,
    jwtToken:false,
}

export default {
    state,
    actions,
    mutations,
    getters
}